import { type PlatformEvent } from '../types';

export const mainPageLoadEvent = (source?: string): PlatformEvent => {
  return {
    type: 'main_page',
    created: Date.now(),
    user_properties: {},
    event_properties: {
      name: 'main_page',
      source,
    },
  };
};
